function config(){

    let GA_tracking_id = 'G-9Z1R6BTJCN'; 

    return{
        // GA tracking id
        ga_id: GA_tracking_id,
    };
}

export default config();